import type {NodeParameters} from "@cm/graph-v3"
import {TemplateNode} from "#template/template-node/template-node"

export abstract class VariableNode<
    out Parameters extends NodeParameters = NodeParameters,
    out ConstructorParameters extends NodeParameters = Parameters,
> extends TemplateNode<Parameters, ConstructorParameters> {}
